import { useQuery } from "@apollo/client";
import { GetIssue } from "../../../../Utils/AllPagesQuriesAndMutations";
import { Loading } from "../../../Components";
import { IssuePage } from "../../../Components/RequestSupportComponent/IssuePages/IssuePage";
export const HoldIssues = () => {
  let { data, loading } = useQuery(GetIssue, {
    variables: { Status: "Hold" },
  });
  if (loading) {
    return <Loading />;
  }
  return (
    <>
      {/* <IssuePage data={Issues} title="Hold Issue" /> */}
      {data?.getrequestSupportWithStatus && (
        <IssuePage data={data?.getrequestSupportWithStatus} title="Hold Issue" modal={false} />
      )}
    </>
  );
};
